import { render, staticRenderFns } from "./MaquinasForm.vue?vue&type=template&id=3a50aa1f&scoped=true&"
import script from "./MaquinasForm.vue?vue&type=script&lang=js&"
export * from "./MaquinasForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a50aa1f",
  null
  
)

export default component.exports